import React from "react";

const GlobalFoundersItem = ({ itemLabel, itemValue }) => {
  return (
    <div className="flex flex-col gap-2">
      <p className="text-xs leading-[14px] text-semiBlack dark:text-semiWhite tracking-[0.015em]">
        {itemLabel}
      </p>
      <p className="text-black dark:text-white font-semibold text-xl leading-6">
        {itemValue}
      </p>
    </div>
  );
};

export default GlobalFoundersItem;
